import { render, staticRenderFns } from "./ChipSelect.vue?vue&type=template&id=134695e6&scoped=true&"
import script from "./ChipSelect.vue?vue&type=script&lang=js&"
export * from "./ChipSelect.vue?vue&type=script&lang=js&"
import style0 from "./ChipSelect.vue?vue&type=style&index=0&id=134695e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134695e6",
  null
  
)

export default component.exports